window.FontAwesomeConfig = {
	searchPseudoElements: true
};


// Place your custom JavaScript here.

$(document).ready(function () {
	

	
	//  $("#myonoffswitch").prop( "checked", true );
	
	function onClickBox() {
		
		let checked=$("#myonoffswitch").is(":checked");
		
		if(checked=$("#myonoffswitch").is(":checked")){
			$(".rsbtn").css("display","none");
		} 
		else{
			$(".rsbtn").css("display","block");
		}
		
		localStorage.setItem("checked", checked);
		} 


	function onReady() {
		if (localStorage.getItem("checked") === null) {
			localStorage.setItem("checked", true);
		  }
		
		// localStorage.setItem("checked", true);

		let checked="true"==localStorage.getItem("checked");
		if(checked="true"==localStorage.getItem("checked")){
		$(".rsbtn").css("display","none");
		} else{
		$(".rsbtn").css("display","block");
		} 
		$("#myonoffswitch").prop('checked', checked);
		$("#myonoffswitch").click(onClickBox);
		} 
		$(document).ready(onReady);

	/* function that returns boolean in case the browser is Internet Explorer */
	function isIE() {
		ua = navigator.userAgent;
		/* MSIE used to detect old browsers and Trident used to newer ones*/
		var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
		
		return is_ie; 
	  }
	  /* Create an alert to show if the browser is IE or not */
	  if (isIE()){
		  
		$( '.flickity-viewport').each(function () {
			this.style.setProperty( 'height', '350px', 'important' );
		});
		$( '.flickity-button').each(function () {
			this.style.setProperty( 'top', '60%', 'important' );
		});
		

		  console.log('It is Internet Explorer');
	  }else{
		
		  
	  };


	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
		if ($(this).innerWidth() / $(this).innerHeight() > 1.5) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			$(this).wrap("<div class='responsive-embed'/>");
		}
	});

	if (!$('.top-bar-overlay li').hasClass('hide animated')) {
		$('.top-bar-overlay li').each(function (index) {
			let item = $(this);
			item.addClass(`hide animated delay-${index}`);
		});
	}

	$("[data-toggle='top-bar-overlay']").click(() => {
		if ($('.top-bar-overlay').hasClass('hidden')) {
			$('.top-bar-overlay').removeClass('hidden');
			$('.overlay-logo').addClass('fadeInUp');
			$('.trail').addClass('zoomIn');
			$('.overlay-portfolio').addClass('fadeInUp');
			$('.top-bar-overlay li').each(function (index) {
				let item = $(this);
				item.removeClass('hide');
				item.addClass('fadeInUp');
			});
		} else {
			$('.top-bar-overlay').addClass('hidden');
			$('.overlay-logo').removeClass('fadeInUp');
			$('.trail').removeClass('zoomIn');
			$('.overlay-portfolio').removeClass('fadeInUp');
			$('.top-bar-overlay li').each(function () {
				let item = $(this);
				item.addClass('hide');
				item.removeClass('fadeInUp');
			});
		}
		$('body').toggleClass('no-scroll');
	});

	$('.sticky')
		.on('sticky.zf.stuckto:top', () => {
			$('[data-logo]').addClass('hide');
			$('[data-logo-dark]').removeClass('hide');
		})
		.on('sticky.zf.unstuckfrom:top', () => {
			$('[data-logo]').removeClass('hide');
			$('[data-logo-dark]').addClass('hide');
		});

	//ANIMATED HEADLINE
	let animationDelay = 2000; //set animation timing
	const barAnimationDelay = 3800; //loading bar effect
	const barWaiting = barAnimationDelay - 3000; //3000 is the duration of the transition on the loading bar - set in the scss/css file
	const lettersDelay = 50; //letters effect
	const typeLettersDelay = 125; //type effect
	const selectionDuration = 500;
	const typeAnimationDelay = selectionDuration + 250;

	initHeadline();

	function initHeadline() {
		//insert <i> element for each letter of a changing word
		singleLetters($('.cd-headline.letters').find('b'));
		//initialise headline animation
		animateHeadline($('.cd-headline'));
	}

	function singleLetters($words) {
		$words.each(function () {
			const word = $(this);
			let i;
			const letters = word.text().split('');
			const selected = word.hasClass('is-visible');
			for (i in letters) {
				if (word.parents('.rotate-2').length > 0) letters[i] = `<em>${letters[i]}</em>`;
				letters[i] = (selected) ? `<span class="in">${letters[i]}</span>` : `<span>${letters[i]}</span>`;
			}
			const newLetters = letters.join('');
			word.html(newLetters).css('opacity', 1);
		});
	}

	function animateHeadline($headlines) {
		const duration = animationDelay;
		$headlines.each(function () {
			const headline = $(this);

			if (!headline.hasClass('type')) {
				//assign to .cd-words-wrapper the width of its longest word
				const words = headline.find('.cd-words-wrapper b');

				let width = 0;
				words.each(function () {
					const wordWidth = $(this).width();
					if (wordWidth > width) width = wordWidth;
				});
				headline.find('.cd-words-wrapper').css('width', width);
			}

			//trigger animation
			setTimeout(() => {
				hideWord(headline.find('.is-visible').eq(0));
			}, duration);
		});
	}

	function hideWord($word) {
		const nextWord = takeNext($word);
		if ($word.parents('.cd-headline').hasClass('type')) {
			const parentSpan = $word.parent('.cd-words-wrapper');
			parentSpan.addClass('selected').removeClass('waiting');
			setTimeout(() => {
				parentSpan.removeClass('selected');
				$word.removeClass('is-visible').addClass('is-hidden').children('span').removeClass('in').addClass('out');
			}, selectionDuration);
			setTimeout(() => {
				showWord(nextWord, typeLettersDelay);
			}, typeAnimationDelay);

		} else if ($word.parents('.cd-headline').hasClass('letters')) {
			const bool = ($word.children('span').length >= nextWord.children('span').length) ? true : false;
			hideLetter($word.find('span').eq(0), $word, bool, lettersDelay);
			showLetter(nextWord.find('span').eq(0), nextWord, bool, lettersDelay);

		} else {
			switchWord($word, nextWord);
			setTimeout(() => {
				hideWord(nextWord);
			}, animationDelay);
		}
	}

	function showWord($word, $duration) {
		if ($word.parents('.cd-headline').hasClass('type')) {
			showLetter($word.find('span').eq(0), $word, false, $duration);
			$word.addClass('is-visible').removeClass('is-hidden');

		}
	}

	function hideLetter($letter, $word, $bool, $duration) {
		$letter.removeClass('in').addClass('out');

		if (!$letter.is(':last-child')) {
			setTimeout(() => {
				hideLetter($letter.next(), $word, $bool, $duration);
			}, $duration);
		} else if ($bool) {
			setTimeout(() => {
				hideWord(takeNext($word));
			}, animationDelay);
		}

		if ($letter.is(':last-child') && $('html').hasClass('no-csstransitions')) {
			const nextWord = takeNext($word);
			switchWord($word, nextWord);
		}
	}

	function showLetter($letter, $word, $bool, $duration) {
		$letter.addClass('in').removeClass('out');

		if (!$letter.is(':last-child')) {
			setTimeout(() => {
				showLetter($letter.next(), $word, $bool, $duration);
			}, $duration);
		} else {
			if ($word.parents('.cd-headline').hasClass('type')) {
				setTimeout(() => {
					$word.parents('.cd-words-wrapper').addClass('waiting');
				}, 200);
			}
			if ($word.is(':last-child')) {
				animationDelay = 5000;
			} else {
				animationDelay = 2000;
			}
			if (!$bool) {
				setTimeout(() => {
					hideWord($word);
				}, animationDelay);
			}
		}
	}

	function takeNext($word) {
		return (!$word.is(':last-child')) ? $word.next() : $word.parent().children().eq(0);
	}

	function takePrev($word) {
		return (!$word.is(':first-child')) ? $word.prev() : $word.parent().children().last();
	}

	function switchWord($oldWord, $newWord) {
		$oldWord.removeClass('is-visible').addClass('is-hidden');
		$newWord.removeClass('is-hidden').addClass('is-visible');
	}
});

($ => {
	/*
	 *  new_map
	 *
	 *  This function will render a Google Map onto the selected jQuery element
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	4.3.0
	 *
	 *  @param	$el (jQuery element)
	 *  @return	n/a
	 */

	function new_map($el) {
		// var
		const $markers = $el.find('.marker');

		// vars
		const args = {
			zoom: 16,
			center: new google.maps.LatLng(0, 0),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
		};

		// create map
		const map = new google.maps.Map($el[0], args);

		// add a markers reference
		map.markers = [];

		// add markers
		$markers.each(function () {
			add_marker($(this), map);
		});

		// center map
		center_map(map);

		// return
		return map;
	}

	/*
	 *  add_marker
	 *
	 *  This function will add a marker to the selected Google Map
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	4.3.0
	 *
	 *  @param	$marker (jQuery element)
	 *  @param	map (Google Map object)
	 *  @return	n/a
	 */

	function add_marker($marker, map) {
		// var
		const latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

		// create marker
		const marker = new google.maps.Marker({
			position: latlng,
			map,
		});

		// add to array
		map.markers.push(marker);

		// if marker contains HTML, add it to an infoWindow
		if ($marker.html()) {
			// create info window
			const infowindow = new google.maps.InfoWindow({
				content: $marker.html(),
			});

			// show info window when marker is clicked
			google.maps.event.addListener(marker, 'click', () => {
				infowindow.open(map, marker);
			});
		}
	}

	/*
	 *  center_map
	 *
	 *  This function will center the map, showing all markers attached to this map
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	4.3.0
	 *
	 *  @param	map (Google Map object)
	 *  @return	n/a
	 */

	function center_map(map) {
		// vars
		const bounds = new google.maps.LatLngBounds();

		// loop through all markers and create bounds
		$.each(map.markers, (i, marker) => {
			const latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

			bounds.extend(latlng);
		});

		// only 1 marker?
		if (map.markers.length == 1) {
			// set center of map
			map.setCenter(bounds.getCenter());
			map.setZoom(13);
		} else {
			// fit to bounds
			map.fitBounds(bounds);
		}
	}

	/*
	 *  document ready
	 *
	 *  This function will render each map when the document is ready (page has loaded)
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	5.0.0
	 *
	 *  @param	n/a
	 *  @return	n/a
	 */
	// global var
	let map = null;

	$(document).ready(() => {
		$('.acf-map').each(function () {
			// create map
			map = new_map($(this));
		});
	});
})(jQuery);